export const MoneyBagIcon = (props: React.ComponentProps<'svg'>) => {
  return (
    <svg
      width="102"
      height="102"
      viewBox="0 0 102 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_b_1794_1583)">
        <rect
          width="102"
          height="102"
          rx="12.5446"
          fill="white"
          fillOpacity="0.1"
        />
        <g clipPath="url(#clip0_1794_1583)">
          <path
            d="M64.3972 66.5558H79.6805C78.3972 49.6197 71.1055 39.1002 61.7527 32.878L66.011 23.5836C66.1398 23.2886 66.1933 22.9664 66.1668 22.6457C66.1403 22.325 66.0346 22.0158 65.8593 21.746C65.6839 21.4762 65.4443 21.2542 65.162 21.0998C64.8796 20.9453 64.5634 20.8634 64.2416 20.8613H37.5833C37.2615 20.8634 36.9452 20.9453 36.6629 21.0998C36.3806 21.2542 36.141 21.4762 35.9656 21.746C35.7902 22.0158 35.6846 22.325 35.6581 22.6457C35.6316 22.9664 35.6851 23.2886 35.8138 23.5836L38.1472 28.6391H57.8249L56.0749 32.528H52.4777C53.5763 35.4821 54.3839 38.5364 54.8888 41.6474C55.2159 43.5772 55.4237 45.5254 55.511 47.4808L52.4388 49.6391C52.4472 47.124 52.239 44.6129 51.8166 42.1335C51.2793 38.8338 50.3525 35.6094 49.0555 32.528H47.111C45.3166 34.7953 43.7042 37.201 42.2888 39.7224C41.1476 41.8853 40.1789 44.1349 39.3916 46.4502L36.7277 44.6808C37.5053 42.443 38.4611 40.2712 39.586 38.1863C40.7227 36.2313 41.9691 34.3421 43.3194 32.528H39.9166L40.0722 32.8586C29.7666 39.7224 21.9305 51.778 21.9305 71.903C21.9042 72.326 21.962 72.7501 22.1006 73.1507C22.2391 73.5512 22.4557 73.9204 22.7377 74.2368C23.0198 74.5532 23.3617 74.8105 23.7438 74.994C24.1259 75.1775 24.5406 75.2835 24.9638 75.3058H40.5194C39.8514 74.6106 39.3902 73.7432 39.1875 72.8007C38.9847 71.8582 39.0484 70.8779 39.3714 69.9695C39.6943 69.0611 40.2638 68.2607 41.0161 67.6577C41.7683 67.0548 42.6736 66.6732 43.6305 66.5558C43.1648 65.766 42.9166 64.867 42.911 63.9502C42.911 62.5578 43.4642 61.2225 44.4487 60.2379C45.4333 59.2533 46.7687 58.7002 48.161 58.7002H59.8277C61.2201 58.7002 62.5555 59.2533 63.54 60.2379C64.5246 61.2225 65.0777 62.5578 65.0777 63.9502C65.0877 64.8639 64.8527 65.7637 64.3972 66.5558Z"
            fill="white"
          />
          <path
            d="M57.9999 71.4171C57.9999 70.9014 57.795 70.4068 57.4304 70.0422C57.0657 69.6775 56.5711 69.4727 56.0554 69.4727H44.3888C43.8731 69.4727 43.3785 69.6775 43.0138 70.0422C42.6492 70.4068 42.4443 70.9014 42.4443 71.4171C42.4443 71.9328 42.6492 72.4274 43.0138 72.792C43.3785 73.1567 43.8731 73.3615 44.3888 73.3615H56.0554C56.5711 73.3615 57.0657 73.1567 57.4304 72.792C57.795 72.4274 57.9999 71.9328 57.9999 71.4171Z"
            fill="white"
          />
          <path
            d="M59.8277 61.6943H48.161C47.6453 61.6943 47.1507 61.8992 46.7861 62.2638C46.4214 62.6285 46.2166 63.1231 46.2166 63.6388C46.2166 64.1545 46.4214 64.6491 46.7861 65.0137C47.1507 65.3784 47.6453 65.5832 48.161 65.5832H59.8277C60.3434 65.5832 60.8379 65.3784 61.2026 65.0137C61.5672 64.6491 61.7721 64.1545 61.7721 63.6388C61.7721 63.1231 61.5672 62.6285 61.2026 62.2638C60.8379 61.8992 60.3434 61.6943 59.8277 61.6943Z"
            fill="white"
          />
          <path
            d="M58.7779 77.25H47.1112C46.5955 77.25 46.1009 77.4549 45.7363 77.8195C45.3716 78.1842 45.1667 78.6787 45.1667 79.1944C45.1667 79.7101 45.3716 80.2047 45.7363 80.5694C46.1009 80.934 46.5955 81.1389 47.1112 81.1389H58.7779C59.2936 81.1389 59.7881 80.934 60.1528 80.5694C60.5174 80.2047 60.7223 79.7101 60.7223 79.1944C60.7223 78.6787 60.5174 78.1842 60.1528 77.8195C59.7881 77.4549 59.2936 77.25 58.7779 77.25Z"
            fill="white"
          />
          <path
            d="M79.5834 77.25H65.9723C65.4566 77.25 64.962 77.4549 64.5973 77.8195C64.2327 78.1842 64.0278 78.6787 64.0278 79.1944C64.0278 79.7101 64.2327 80.2047 64.5973 80.5694C64.962 80.934 65.4566 81.1389 65.9723 81.1389H79.5834C80.0991 81.1389 80.5937 80.934 80.9583 80.5694C81.323 80.2047 81.5278 79.7101 81.5278 79.1944C81.5278 78.6787 81.323 78.1842 80.9583 77.8195C80.5937 77.4549 80.0991 77.25 79.5834 77.25Z"
            fill="white"
          />
          <path
            d="M81.5277 69.4727H67.9166C67.4009 69.4727 66.9063 69.6775 66.5417 70.0422C66.177 70.4068 65.9722 70.9014 65.9722 71.4171C65.9722 71.9328 66.177 72.4274 66.5417 72.792C66.9063 73.1567 67.4009 73.3615 67.9166 73.3615H81.5277C82.0434 73.3615 82.538 73.1567 82.9027 72.792C83.2673 72.4274 83.4722 71.9328 83.4722 71.4171C83.4722 70.9014 83.2673 70.4068 82.9027 70.0422C82.538 69.6775 82.0434 69.4727 81.5277 69.4727Z"
            fill="white"
          />
        </g>
        <rect
          x="0.418153"
          y="0.418153"
          width="101.164"
          height="101.164"
          rx="12.1264"
          stroke="url(#paint0_linear_1794_1583)"
          strokeWidth="0.836306"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_1794_1583"
          x="-21.744"
          y="-21.744"
          width="145.488"
          height="145.488"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="10.872" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1794_1583"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1794_1583"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1794_1583"
          x1="9.12934"
          y1="-9.36905e-07"
          x2="55.009"
          y2="61.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_1794_1583">
          <rect
            width="70"
            height="70"
            fill="white"
            transform="translate(16 16)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
